module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar navbar-default",
    staticStyle: {
      "background": "#70b1e7",
      "border-bottom-color": "black"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-right-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-left",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(this.$sessionService.getRole() === 'ADMIN' || this.$sessionService.getRole() === 'DISPATCHER') ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.maps
    }
  }, [_c('i', {
    staticClass: "ti-map"
  }), _vm._v(" "), _c('p', [_vm._v("Mapa")])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getRole() === 'ADMIN' || this.$sessionService.getRole() === 'DISPATCHER') ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": function($event) {
        return _vm.testAI()
      }
    }
  }, [_c('i', {
    staticClass: "ti-rocket"
  }), _vm._v(" "), _c('p', [_vm._v("Test AI")])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getRole() === 'ADMIN' || this.$sessionService.getRole() === 'DISPATCHER') ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.orders
    }
  }, [_c('i', {
    staticClass: "ti-list"
  }), _vm._v(" "), _c('p', [_vm._v("Porudžbine "), (_vm.numberOfNewOrders > 0) ? _c('b', {
    staticStyle: {
      "background": "#d33",
      "padding": "8px",
      "border-radius": "100px"
    }
  }, [_vm._v(_vm._s(_vm.numberOfNewOrders))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getRole() === 'ADMIN' || this.$sessionService.getRole() === 'DISPATCHER') ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.schedule
    }
  }, [_c('i', {
    staticClass: "ti-calendar"
  }), _vm._v(" "), _c('p', [_vm._v("Raspored "), (_vm.numberOfNewVacations > 0) ? _c('b', {
    staticStyle: {
      "background": "#d33",
      "padding": "8px",
      "border-radius": "100px"
    }
  }, [_vm._v(_vm._s(_vm.numberOfNewVacations))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getRole() === 'ADMIN' || this.$sessionService.getRole() === 'DISPATCHER') ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.drivers
    }
  }, [_c('i', {
    staticClass: "ti-user"
  }), _vm._v(" "), _c('p', [_vm._v("Kuriri")])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getRole() === 'ADMIN') ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.dispatchers
    }
  }, [_c('i', {
    staticClass: "ti-user"
  }), _vm._v(" "), _c('p', [_vm._v("Dispečeri")])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getRole() === 'ADMIN' || this.$sessionService.getRole() === 'DISPATCHER') ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.companies
    }
  }, [_c('i', {
    staticClass: "ti-list"
  }), _vm._v(" "), _c('p', [_vm._v("Kompanije")])])]) : _vm._e(), _vm._v(" "), ((this.$sessionService.getRole() === 'ADMIN' || this.$sessionService.getRole() === 'DISPATCHER')) ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.vehicle
    }
  }, [_c('i', {
    staticClass: "ti-car"
  }), _vm._v(" "), _c('p', [_vm._v("Vozila")])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getRole() === 'ADMIN' || this.$sessionService.getRole() === 'DISPATCHER') ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.price
    }
  }, [_c('i', {
    staticClass: "ti-money"
  }), _vm._v(" "), _c('p', [_vm._v("Cenovnik")])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getRole() === 'ADMIN' || this.$sessionService.getRole() === 'DISPATCHER') ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.configuration
    }
  }, [_c('i', {
    staticClass: "ti-settings"
  }), _vm._v(" "), _c('p', [_vm._v("Konfiguracija")])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getRole() === 'ADMIN' || this.$sessionService.getRole() === 'DISPATCHER') ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.rateAndBugs
    }
  }, [_c('i', {
    staticClass: "ti-star"
  }), _vm._v(" "), _c('p', [_vm._v("Ocene/Kvarovi")])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getRole() === 'ADMIN') ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.reportSchedule
    }
  }, [_c('i', {
    staticClass: "ti-download"
  }), _vm._v(" "), _c('p', [_vm._v("Izvestaj vozači")])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getRole() === 'ADMIN') ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.orderReport
    }
  }, [_c('i', {
    staticClass: "ti-download"
  }), _vm._v(" "), _c('p', [_vm._v("Izvestaj kompanije")])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getRole() === 'ADMIN') ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.averageReport
    }
  }, [_c('i', {
    staticClass: "ti-download"
  }), _vm._v(" "), _c('p', [_vm._v("Prosečno vreme")])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getRole() === 'ADMIN') ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.vehicleReport
    }
  }, [_c('i', {
    staticClass: "ti-download"
  }), _vm._v(" "), _c('p', [_vm._v("Izveštaj vozila")])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getRole() === 'ADMIN') ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.customers
    }
  }, [_c('i', {
    staticClass: "ti-user"
  }), _vm._v(" "), _c('p', [_vm._v("Korisnici")])])]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.profile
    }
  }, [_c('i', {
    staticClass: "ti-user"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.username))])])]), _vm._v(" "), (this.$sessionService.getAccessToken() != null) ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.signOut
    }
  }, [_c('i', {
    staticClass: "ti-power-off"
  }), _vm._v(" "), _c('p', [_vm._v("Odjava")])])]) : _vm._e(), _vm._v(" "), (this.$sessionService.getAccessToken() == null) ? _c('li', [_c('a', {
    staticClass: "btn-rotate",
    staticStyle: {
      "color": "black",
      "font-size": "11pt"
    },
    on: {
      "click": _vm.signOut
    }
  }, [_c('i', {
    staticClass: "ti-power-off"
  }), _vm._v(" "), _c('p', [_vm._v("Prijava")])])]) : _vm._e()])])])]), _vm._v(" "), _c('change-password-modal', {
    attrs: {
      "show": _vm.changePasswordModalVisible
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e110648a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/TopNavbar.vue
// module id = 512
// module chunks = 1